/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { lazy } from "react";

export function componentLoader(
    lazyComponent: any,
    attemptsLeft: number = 3,
    interval = 1500
) {
    return new Promise((resolve, reject) => {
        lazyComponent()
            .then(resolve)
            .catch((error: any) => {
                // let us retry after 1500 ms
                console.log("error in comp loading", error);
                alert(error?.message);
                setTimeout(() => {
                    if (attemptsLeft === 1) {
                        reject(error);
                        return;
                    }
                    componentLoader(lazyComponent, attemptsLeft - 1).then(
                        resolve,
                        reject
                    );
                }, interval);
            });
    });
}

export const lazyWithRetry = (componentImport: any) =>
    lazy(async () => {
        const pageHasAlreadyBeenForceRefreshed = JSON.parse(
            window.localStorage.getItem("page-has-been-force-refreshed") ||
                "false"
        );

        try {
            const component = await componentImport();

            window.localStorage.setItem(
                "page-has-been-force-refreshed",
                "false"
            );

            return component;
        } catch (error) {
            console.log("error in loading", error);
            if (!pageHasAlreadyBeenForceRefreshed) {
                // Assuming that the user is not on the latest version of the application.
                // Let's refresh the page immediately.
                window.localStorage.setItem(
                    "page-has-been-force-refreshed",
                    "true"
                );
                return window.location.reload();
            }
            console.log("error in loading genuine", error);
            // The page has already been reloaded
            // Assuming that user is already using the latest version of the application.
            // Let's let the application crash and raise the error.
            throw error;
        }
    });
